export const isCustomizableMadePage = () => window.location.pathname.includes("custom-printed-");

export const isCustomizablePlp = () => window.location.href.includes("customizable");

export const isFlashPdp = () => window.location.href.includes("sameday=true");

export const isMadeSamplePdp = () => {
  // Check if it's a made dedicated PDP with sample parameter
  const url = window.location.href;
  const { pathname } = window.location;
  const isMadePdp = pathname.includes("/custom-printed-") || pathname.endsWith(".html");
  const hasSampleParam = url.includes("sample=true");
  return isMadePdp && hasSampleParam;
};

export const getMadeProductType = isSample => {
  const isActuallySample = typeof isSample === "boolean" ? isSample : isMadeSamplePdp();
  return isActuallySample ? "made_sample_pdp" : "made_pdp";
};

export const getFlashDeliveryText = (earliestDelivery, earliestDeliveryDay) => {
  if (isFlashPdp()) {
    return `Get ${earliestDeliveryDay}`;
  }
  return earliestDeliveryDay;
};

export const getPageSourceParam = () => {
  if (isFlashPdp()) {
    return "flash_on_made_dedicated_pdp";
  }
  if (isMadeSamplePdp()) {
    return "made_sample_pdp";
  }
  if (isCustomizableMadePage()) {
    return "made_pdp";
  }
  return "flash_on_blanks_pdp";
};

export default {};
